export default __webpack_public_path__ + "static/github-6176d1aa7836bc99d7dffc9196467ea6.svg";